import { AppDoubleHeaderNavigationState } from '../../../initialStateRegistration';

export const getSecondaryHeader = (state: AppDoubleHeaderNavigationState) => state.secondaryHeader;
